import { render, staticRenderFns } from "./PopupBackdrop.vue?vue&type=template&id=453144f8&scoped=true&"
import script from "./PopupBackdrop.vue?vue&type=script&lang=ts&"
export * from "./PopupBackdrop.vue?vue&type=script&lang=ts&"
import style0 from "./PopupBackdrop.vue?vue&type=style&index=0&id=453144f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453144f8",
  null
  
)

export default component.exports